import { makeStyles } from '@material-ui/core';
import { HEAT_STEPS, HEAT_TEXT, heatStep, heatFloor } from '../tournament/participant/palette';

const useStyles = makeStyles(theme => ({
    board: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 4,
        width: '100%',
        maxWidth: 200,
        margin: '0 auto'
    },
    cell: {
        position: 'relative',
        paddingTop: '100%',
        borderRadius: 4
    },
    empty: {
        backgroundColor: theme.palette.background.default,
        border: `1px dashed ${theme.palette.divider}`
    },
    count: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.5rem',
        fontWeight: 'bold'
    }
}));

// The grid distribution of one contestant, without the card around it - the
// slideshow shows two of these side by side.
function HeatGrid(props) {
    const classes = useStyles();
    const grid = props.grid ?? new Array(9).fill(0);
    const max = Math.max(...grid);
    const min = heatFloor(grid);
    return (
        <div className={classes.board}>
            {grid.map((count, index) => {
                const step = heatStep(count, max, min);
                return (
                    <div
                        key={index}
                        className={`${classes.cell} ${step === -1 ? classes.empty : ''}`}
                        style={step === -1 ? undefined : { backgroundColor: HEAT_STEPS[step] }}
                    >
                        <span
                            className={classes.count}
                            style={{ color: step === -1 ? 'inherit' : HEAT_TEXT[step] }}
                        >
                            {count}
                        </span>
                    </div>
                );
            })}
        </div>
    );
}

export default HeatGrid;
